import i18next from 'i18next';

type MissingKeyInfo = {
  lng: string;
  key: string;
  ns?: string;
};

class MissingKeysLogger {
  private seen = new Set<string>();

  // Optional: flip this on/off easily
  public enabled = true;

  // Optional: provide a callback to send missing keys to backend
  public onMissing?: (info: MissingKeyInfo) => void;

  markMissing(key: string) {
    if (!this.enabled) return;

    const lng = i18next.language || 'unknown';
    const ns = key.includes(':') ? key.split(':')[0] : undefined;
    const fingerprint = `${lng}::${key}`;

    if (this.seen.has(fingerprint)) return;
    this.seen.add(fingerprint);

    // Console log (once per lng+key)
    // You can include stack traces if you want by adding `console.trace()`.
    // eslint-disable-next-line no-console
    console.warn(`[i18n] Missing key for "${lng}": "${key}"`);

    if (this.onMissing) {
      try {
        this.onMissing({ lng, key, ns });
      } catch {
        // ignore reporter errors
      }
    }
  }

  resetForLanguage(lng: string) {
    // if you want to re-log missing keys after a language switch
    // comment out if you want "log once forever"
    // this.seen = new Set([...this.seen].filter(x => !x.startsWith(`${lng}::`)));
  }
}

export const missingKeysLogger = new MissingKeysLogger();
